module.exports = __webpack_public_path__ + "static/media/ProceduresIcon.2f6eecdc.svg";